import { useMediaQuery } from '@mui/material';
import { isNil } from 'lodash';
import { useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { EffectCreative, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTabBarFuncs } from '../../hooks/responsive/useTabBarFuncs';
import { useDeviceSize } from '../../hooks/useDeviceSize';
import { getTabsConfig } from '../../constants';
import { getUrlQueryParam } from '../../common/url';

export function TabBar() {
  const { isReview, isShowSharing, activeTabBarId } = useSelector((state) => state.ui);
  const swiperRef = useRef(null);
  const { width } = useDeviceSize();
  const isMobile = useMediaQuery('(max-width:600px)');
  const isSpecialCase = useMediaQuery('(min-width:540px) and (max-width:600px)');
  const { handleClick, handleActiveIndexChanged } = useTabBarFuncs(swiperRef);
  
  // Get fullCustom from URL query parameter
  const fullCustom = getUrlQueryParam('fullCustom');
  const TABS_CONFIG = useMemo(() => getTabsConfig(fullCustom), [fullCustom]);

  const handleTabBarPosition = () => {
    const bgCanvasEl = document.getElementById('background-canvas');
    const tabBarSwiperEl = document.getElementById('tab-bar-swiper');
    if (!tabBarSwiperEl && !bgCanvasEl) return;

    const bgHeight = bgCanvasEl.getBoundingClientRect().height;
    tabBarSwiperEl.style.paddingTop = isMobile ? `${bgHeight - 140}px` : `${bgHeight - 120}px`;

    if (isSpecialCase) {
      bgCanvasEl.style.top = '-80px';
      tabBarSwiperEl.style.paddingTop = `${bgHeight - 120}px`;
    } else {
      bgCanvasEl.style.top = '-60px';
    }
  };

  useEffect(() => {
    handleTabBarPosition();
    const item = TABS_CONFIG.find((e) => e.fcID === activeTabBarId);
    const index = TABS_CONFIG.findIndex((e) => e.fcID === activeTabBarId);
    if (isNil(item) || index < 0) return;
    handleClick(item, index);
  }, [TABS_CONFIG, activeTabBarId, handleClick]);

  return (
    !isReview &&
    !isShowSharing && (
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: isMobile ? 160 : 230,
        }}
      >
        <div
          id="background-canvas"
          style={{
            position: 'absolute',
            width: '100%',
            height: 'auto',
            backgroundImage:
              width >= 500
                ? 'url("/theme/img/background/tablet.svg")'
                : 'url("/theme/img/background/bottom.svg")',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            zIndex: 1,
          }}
        >
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              paddingBottom: '10px',
            }}
          >
            <Swiper
              id="tab-bar-swiper"
              slidesPerView={5}
              watchSlidesProgress={true}
              ref={swiperRef}
              onInit={(swiper) => {
                swiperRef.current = swiper;
              }}
              onSlideChange={(swiper) => {
                if (swiper.swipeDirection) {
                  handleActiveIndexChanged(TABS_CONFIG[swiper.realIndex]?.fcID);
                }
              }}
              centeredSlides={true}
              creativeEffect={{
                limitProgress: 4,
                prev: {
                  opacity: 1,
                  scale: 0.95,
                  translate: ['-100%', -15, 0],
                },
                next: {
                  opacity: 1,
                  scale: 0.95,
                  translate: ['100%', -15, 0],
                },
              }}
              effect="creative"
              loopAdditionalSlides={true}
              loopPreventsSliding={false}
              loopAddBlankSlides={false}
              loop={true}
              modules={[Pagination, Navigation, EffectCreative]}
              style={{
                height: '260px',
                paddingLeft: '16px',
                paddingRight: '16px',
              }}
            >
              {TABS_CONFIG?.map((item, index) => (
                <SwiperSlide key={`${item.fcID}-${item.id}-${index}`}>
                  <div
                    key={item.id}
                    className="item"
                    onClick={() => handleClick(item, index)}
                    style={{
                      backgroundImage: 'url(/theme/img/bgIcon.png)',
                      margin: 'auto',
                      display: 'flex',
                    }}
                  >
                    <img src={item.logo} alt={`iconLogo${index + 1}`} width={30}></img>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    )
  );
}
